<!-- zpanos created this Modal Because More Bet Info Modal Was having problems
     displaying from weekly and affilate summary, Because It was a modal on top of the modal. The goal was to remove the
     Background in this version of the modal so that user would not get a failed image.
     This Is NOT SCALABLE AND SHOULD JUST BE INCORPORATED AS A V2 OF A MODAL
!-->
<template>
  <div>
    <div v-if="!loading" class="row double-bet-info">
      <div class="col-3 info-title font-weight-bold">Game:</div>
      <div
        v-if="
          !completeBet.game.isFutures && completeBet.game.participants.length
        "
        class="col-9 font-weight-bold"
      >
        {{
          userStore.user.defaultRotationNumbers ||
          userStore.user.displayRotationNumbers
            ? completeBet.game.participants[0].rotationNumber
            : ''
        }}
        {{ completeBet.game.participants[0].longName }}
        <span class="info-title"> @ </span>
        {{
          userStore.user.defaultRotationNumbers ||
          userStore.user.displayRotationNumbers
            ? completeBet.game.participants[1].rotationNumber
            : ''
        }}
        {{ completeBet.game.participants[1].longName }}
      </div>
      <div v-else class="col-9 font-weight-bold">
        {{ completeBet.game.eventName }}
      </div>
      <div class="col-3 info-title font-weight-bold">League:</div>
      <div class="col-9 font-weight-bold">
        {{ completeBet.game.league }}
      </div>
      <div class="col-3 info-title font-weight-bold">Start:</div>
      <div class="col-9 font-weight-bold">
        {{ dayjs(completeBet.game.start).format('DD MMM hh:mm A') }}
      </div>
      <div class="col-3 info-title font-weight-bold">Side:</div>
      <div v-if="completeBet.origin !== 'offer'" class="col-9 font-weight-bold">
        {{ getSideString(completeBet.game, completeBet) }}
        {{ formatOdds(completeBet.odds) }}
      </div>
      <div v-else class="col-9 font-weight-bold">
        {{ getSideString(completeBet.game, completeBet) }}
        {{ formatOddsNoCommission(completeBet.odds) }}
      </div>
      <div class="col-3 info-title font-weight-bold">Bet:</div>
      <div class="col-9 font-weight-bold">
        {{ capitalize(completeBet.type) }}
      </div>
      <div class="col-3 info-title mb-md-0 font-weight-bold">Risk:</div>
      <div class="col-9 font-weight-bold">
        <span v-if="isHalfLoss" class="full-amount-strike"
          >${{ roundToFixed2(computedRisk) }}</span
        >
        ${{ roundToFixed2(isHalfLoss ? computedRisk / 2 : computedRisk) }}
        <div v-if="isHalfLoss" class="half-line-note">{{ halfLineNote }}</div>
      </div>
      <div class="col-3 info-title mb-md-0 font-weight-bold">Win:</div>
      <div class="col-9 font-weight-bold">
        <span v-if="isHalfWin" class="full-amount-strike"
          >${{ roundToFixed2(fullWinAmount) }}</span
        >
        ${{ roundToFixed2(winAmount) }}
        <div v-if="isHalfWin" class="half-line-note">{{ halfLineNote }}</div>
      </div>
      <div class="col-3 info-title mb-md-0 font-weight-bold">Fees Paid:</div>
      <div class="col-9 font-weight-bold">
        ${{ roundToFixed2(completeBet.commissionPaid) }}
      </div>
      <div v-if="completeBet.origin === 'offer'" class="row col-12 p-0 m-0">
        <div class="col-3 info-title mb-md-0 font-weight-bold">Created:</div>
        <div class="col-9 font-weight-bold">
          {{ dayjs(completeBet.createdAt).format('hh:mm A DD MMM') }}
        </div>
      </div>
      <div v-if="completeBet.matchedTime" class="row col-12 p-0 m-0">
        <div class="col-3 info-title mb-md-0 font-weight-bold">
          {{ completeBet.origin === 'offer' ? 'Last Matched:' : 'Matched:' }}
        </div>
        <div class="col-9 font-weight-bold">
          {{ dayjs(completeBet.matchedTime).format('hh:mm A DD MMM') }}
        </div>
      </div>
      <!-- <div class="col-3 info-title mb-md-0 font-weight-bold">
        Matched:
      </div>
      <div class="col-9 font-weight-bold">
        {{ dayjs(completeBet.matchedTime).format('hh:mm A DD MMM') }}
      </div> -->
      <div
        v-if="completeBet.wagerRequestID"
        class="col-3 info-title mb-md-0 font-weight-bold"
      >
        BetID:
      </div>
      <div v-if="completeBet.wagerRequestID" class="col-9 font-weight-bold">
        {{ completeBet.wagerRequestID }}
      </div>
      <div class="col-3 info-title mb-md-0 font-weight-bold">Market:</div>
      <div
        v-if="userStore.user.oddsFormat !== 'decimal'"
        class="col-9 font-weight-bold"
      >
        {{ pinnacleString }}
        {{
          completeBet.pinnacleLine.odds
            ? formatOdds(completeBet.pinnacleLine.odds)
            : ''
        }}
      </div>
      <div v-else class="col-9 font-weight-bold">
        {{ pinnacleString }}
        {{
          completeBet.pinnacleLine.odds
            ? formatDecimalOdds(convertAmericanToDecimal(completeBet.pinnacleLine.odds))
            : ''
        }}
      </div>
      <div
        v-if="completeBet.closingLine && completeBet.closingLine.fairOdds"
        class="row col-12 p-0 m-0"
      >
        <div class="col-3 info-title mb-md-0 font-weight-bold">
          Closing Line:
        </div>
        <div
          v-if="userStore.user.oddsFormat !== 'decimal'"
          class="col-9 font-weight-bold"
        >
          {{ closingLineString }}
          {{ formatOdds(completeBet.closingLine.fairOdds) }}
          {{ offNumberNote }}
        </div>
        <div v-else class="col-9 font-weight-bold">
          {{ closingLineString }}
          {{
            formatDecimalOdds(
              convertAmericanToDecimal(completeBet.closingLine.fairOdds),
            )
          }}
          {{ offNumberNote }}
        </div>
      </div>
      <div class="col-3 info-title mb-md-0 font-weight-bold">Origin:</div>
      <div class="col-9 font-weight-bold">
        {{ capitalize(completeBet.origin) }}
      </div>
      <div class="col-4 align-items-center" />
    </div>
    <div v-else>
      <spinner />
    </div>
  </div>
</template>
<script setup>
// core
import { ref, onMounted, watch, computed } from 'vue';
import { useUserStore } from '@/stores/user';
import dayjs from 'dayjs';
import { useAPI } from '@/composables/useAPI';
import {
  capitalize,
  signOdds,
  calculateWin,
  getSideString,
  getSideStringShort,
  convertAmericanToDecimal,
  getCommissionPct,
  displayWithVig,
  roundToFixed2,
  formatDecimalOdds,
  stripOrderbookData,
  getHalfLineNote,
} from '@/core/utils';
import { formatOdds, formatOddsNoCommission } from '@/core/oddsFormatUtils';
import {
  commissionAdjustedRisk,
  commissionAdjustedWin,
} from '@/core/commissionUtils';

// components
import Spinner from '@/components/global/Spinner.vue';

//props
const props = defineProps({
  bet: {
    type: Object,
    required: true,
  },
});

// get bet info on mount
const loading = ref(true);
const completeBet = ref(null);
onMounted(async () => {
  loading.value = true;

  const { request } = useAPI('/user/getBetInformation');
  await request({ bet: stripOrderbookData(props.bet) }).then((response) => {
    completeBet.value = response.completeBet;
    loading.value = false;
  });
});

// init store
const userStore = useUserStore();

const winAmount = computed(() => {
  let winAmount = calculateWin(completeBet.value.bet, completeBet.value.odds);
  if (completeBet.value.outcome === 'half-win') {
    winAmount /= 2;
  }
  if (!userStore.user.viewOddsWithCommission || props.bet.origin === 'offer')
    return winAmount;
  return commissionAdjustedWin(
    winAmount,
    completeBet.value.game.league.toLowerCase(),
    completeBet.value.type,
  );
});

const isHalfWin = computed(() => completeBet.value?.outcome === 'half-win');
const isHalfLoss = computed(() => completeBet.value?.outcome === 'half-loss');

const fullWinAmount = computed(() => {
  let win = calculateWin(completeBet.value.bet, completeBet.value.odds);
  if (!userStore.user.viewOddsWithCommission || props.bet.origin === 'offer')
    return win;
  return commissionAdjustedWin(
    win,
    completeBet.value.game.league.toLowerCase(),
    completeBet.value.type,
  );
});

const halfLineNote = computed(() =>
  completeBet.value ? getHalfLineNote(completeBet.value) : '',
);

const computedRisk = computed(() => {
  if (!userStore.user.viewOddsWithCommission || props.bet.origin === 'offer')
    return completeBet.value.bet;
  return commissionAdjustedRisk(
    completeBet.value.bet,
    completeBet.value.odds,
    completeBet.value.game.league.toLowerCase(),
    completeBet.value.type,
  );
});

const pinnacleString = computed(() => {
  if (completeBet.value && !loading.value) {
    if (completeBet.value.type === 'total') {
      return `${capitalize(completeBet.value.pinnacleLine.OU)} ${completeBet.value.pinnacleLine.total}`;
    } else if (completeBet.value.type === 'moneyline') {
      return `${completeBet.value.game.participants.find((p) => p.id === completeBet.value.participantID).shortName}`;
    } else if (completeBet.value.type === 'spread') {
      return `${completeBet.value.game.participants.find((p) => p.id === completeBet.value.participantID).shortName} ${signOdds(completeBet.value.pinnacleLine.spread)}`;
    }
  }
  return '';
});

// consensus closing line (server field completeBet.closingLine; null until the
// closing-lines job has covered the game — rows hide themselves then)
const closingLineString = computed(() => {
  const cl = completeBet.value?.closingLine;
  if (!cl) return '';
  if (completeBet.value.type === 'total') {
    return `${capitalize(completeBet.value.OU)} ${cl.number}`;
  }
  const shortName =
    completeBet.value.game.participants.find(
      (p) => p.id === completeBet.value.participantID,
    )?.shortName ?? '';
  if (completeBet.value.type === 'spread') {
    return `${shortName} ${signOdds(cl.number)}`;
  }
  return shortName;
});

// We always show the close even when it landed on a different number than the
// bet (e.g. bet -6.5, market closed -7.5) — but say so, otherwise the differing
// number reads as an error.
const offNumberNote = computed(() => {
  const cl = completeBet.value?.closingLine;
  if (!cl || cl.number === null || cl.number === undefined) return '';
  const betNumber =
    completeBet.value.type === 'spread'
      ? completeBet.value.spread
      : completeBet.value.total;
  if (betNumber === null || betNumber === undefined) return '';
  return Number(betNumber) === Number(cl.number) ? '' : '(main line)';
});

// watch odds Copy
const oddsCopy = ref('');
const sessionYourSide = ref(null);
watch(oddsCopy, async (newValue) => {
  sessionYourSide.value.odds = newValue;
});

// emit close modal
const emit = defineEmits(['closeModal']);
function close() {
  emit('closeModal');
}
</script>

<style scoped lang="scss">
@use '@/scss/theme/variables.scss' as theme;

.modal-wrap {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1001;
  background: none;
  width: 100%;
  height: 100%;
  align-content: center;
  align-items: center;
  justify-content: center;
}

.double-bet-info {
  color: theme.$black;
  .info-title {
    color: theme.$black-203;
  }
  .full-amount-strike {
    color: theme.$black-203;
    text-decoration: line-through;
    font-weight: theme.$font-weight-normal;
    margin-right: 6px;
  }
  .half-line-note {
    font-size: theme.$font-size-xs;
    font-weight: theme.$font-weight-normal;
    color: theme.$grey-2400;
  }
}
</style>
